export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6808.8cb98cd5.jpg";